module.exports = __webpack_public_path__ + "img/france-genitourinary-diseases-female.7a01aae1.png";